import { AccessibleElement } from 'types/widget.types';

import { ResponsiveWidgetBaseData } from '../ResponsiveWidgetBase.types';

enum ComponentWidgetIdKeys {
  QuestionText = 'questionText',
  AnswerText = 'answerText',
}

enum MultipleChoicesType {
  Horizontal = 'Horizontal',
}

interface MultipleChoicesWidgetData extends ResponsiveWidgetBaseData<ComponentWidgetIdKeys>, AccessibleElement {
  type: MultipleChoicesType;
  correctAnswers: string[]; // Correct answers by the editor
  selectedAnswers: string[]; // Selected answers by the user
}

export type { MultipleChoicesWidgetData };
export { MultipleChoicesType, ComponentWidgetIdKeys };
